const Mutations = Object.freeze({
	SET_INTERACTIONS:
		'inventoryFormModule/formBuilder/interactions/SET_INTERACTIONS',
	SET_FORM_FIELDS:
		'inventoryFormModule/formBuilder/interactions/SET_FORM_FIELDS',
});

export const Actions = Object.freeze({
	CLEAR: 'inventoryFormModule/formBuilder/interactions/CLEAR',
	LOAD: 'inventoryFormModule/formBuilder/interactions/LOAD',
	ADD: 'inventoryFormModule/formBuilder/interactions/ADD',
	REMOVE: 'inventoryFormModule/formBuilder/interactions/REMOVE',
	UPDATE: 'inventoryFormModule/formBuilder/interactions/UPDATE',
});

export const Getters = Object.freeze({
	INTERACTIONS: 'inventoryFormModule/formBuilder/interactions/INTERACTIONS',
	FORM_FIELDS: 'inventoryFormModule/formBuilder/interactions/FORM_FIELDS',
});

import { GeneralActions, InventoryFormActions } from '../../../../../actions';
import dataService from '../../../../../../services/data/inventoryFormService';
export default {
	state: {
		interactions: [],
		formFields: [],
	},
	mutations: {
		[Mutations.SET_INTERACTIONS](state, items) {
			state.interactions = items;
		},
		[Mutations.SET_FORM_FIELDS](state, items) {
			state.formFields = items;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_INTERACTIONS, []);
				commit(Mutations.SET_FORM_FIELDS, []);
				resolve();
			});
		},
		[Actions.LOAD]({ commit, dispatch }, inventoryFormId) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				Promise.all([
					dataService
						.getInteractionByInventotyFormId(inventoryFormId)
						.then((resp) => {
							commit(Mutations.SET_INTERACTIONS, resp.data);
						}),
					dataService.getFormFields(inventoryFormId).then((resp) => {
						commit(Mutations.SET_FORM_FIELDS, resp.data);
					}),
				])
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
		[Actions.ADD]({ dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.insertInteraction(item)
					.then((resp) => {
						dispatch(InventoryFormActions.RELOAD);
						dispatch(GeneralActions.LOADING, false);
						resolve({ success: true, data: resp.data });
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve({ success: false });
					});
			});
		},
		[Actions.UPDATE]({ dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updateInteraction(item)
					.then(() => {
						dispatch(InventoryFormActions.RELOAD);
						dispatch(GeneralActions.LOADING, false);
						resolve({ success: true, data: null });
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve({ success: false });
					});
			});
		},
		[Actions.REMOVE]({ dispatch }, itemId) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteInteraction(itemId)
					.then(() => {
						dispatch(InventoryFormActions.RELOAD);
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
	},
	getters: {
		[Getters.INTERACTIONS]: (state) => {
			if (!state.interactions) return [];
			if (state.interactions.length < 0) return [];
			return JSON.parse(JSON.stringify(state.interactions));
		},
		[Getters.FORM_FIELDS]: (state) => {
			if (!state.formFields) return [];
			if (state.formFields.length < 0) return [];
			return JSON.parse(
				JSON.stringify(
					state.formFields.filter((x) => x.HiddenBehaviour === 0)
				)
			);
		},
	},
};
